import { useState, useEffect } from "react";

function useWindowHeight() {
	const [height, setHeight] = useState(window.innerHeight);

	useEffect(() => {
		const handleResize = () => setHeight(window.innerHeight);
		window.addEventListener("resize", handleResize);

		// Clean up
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	return height;
}

export default useWindowHeight;
